export const m8ErrorMessageMap = {
  PASSWOR_MUSTNT_BE_EQUAL_LOGIN: "Password mustn't be equal the login",
  PASSWOR_MUSTNT_BE_MATCH_LOGIN_PART:
    "Password mustn't be match the login part",
  EMAIL_ALREADY_IN_USE: 'Email Address already in use',
  PASSWORD_IS_WRONG: 'Password is wrong',
  USER_ALREADY_HAS_STACK: 'User already has stack',
  USER_HASNT_STACK_PATTERN: "User hasn't stack pattern",
  INVALID_DOMAIN_NAME: 'Invalid domain name',
  CAPTCHA_EXCEPTON: 'Invalid captcha response',
  DEMO_STACK_CREATION_SUSPENDED: 'Free demo stack not found',
  TOKEN_EXPIRATION: 'Token is expired',
  DOMAIN_NAME_ALREADY_IN_USE: 'Dns name already in use',
  AMOUNT_EXCEEDS_THE_BALANCE: 'Amount cannot be greater than balance',
  USER_NOT_FOUND: 'User not found',
  CLIENT_SUBSCRIPTION_IS_CANCELLED: 'Client subscription is cancelled',
  DEBIT_ALREADY_PAID: 'Debit already paid',
  METHOD_WORKS_ONLY_FOR_LAST_DEBIT: 'Method works only for last debit',
};
